<template>
  <div class="contact">
    <!-- title -->
    <el-row>
      <el-col :span="24" :xs="24" class="contact-title">
        {{ $t("contact-title") }}</el-col
      >
    </el-row>
    <el-divider />
    <div class="contact-content">
      <!-- title2 -->
      <el-row>
        <el-col :span="24" :xs="24" class="contact-title2">
          {{ $t("contact-title2") }}</el-col
        >
      </el-row>
      <el-divider />
      <!-- 氏名 -->
      <el-row>
        <el-col :span="6" :xs="6" class="contact-field">
          {{ $t("contact-name") }}</el-col
        >
        <el-col :span="18" :xs="18" class="">
          <el-input
            v-model="contactInfo.name"
            class="contact-input"
            size="large"
          />
        </el-col>
      </el-row>
      <el-divider />
      <!-- E-mail -->
      <el-row>
        <el-col :span="6" :xs="6" class="contact-field">
          {{ $t("contact-email") }}</el-col
        >
        <el-col :span="18" :xs="18" class="">
          <el-input
            v-model="contactInfo.mail"
            class="contact-input"
            size="large"
          />
        </el-col>
      </el-row>
      <el-divider />
      <!-- お問い合わせ内容 -->
      <el-row>
        <el-col :span="6" :xs="6" class="contact-field">
          {{ $t("contact-content") }}</el-col
        >
        <el-col :span="18" :xs="18" class="">
          <el-input
            v-model="contactInfo.content"
            class="contact-input"
            size="large"
            maxlength="500"
            show-word-limit
            type="textarea"
            :rows="20"
          />
        </el-col>
      </el-row>
      <el-divider />
      <el-row justify="center">
        <el-button size="large" class="contact-btn" @click="gotoReview()">{{
          $t("contact-btn")
        }}</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
import { isEmpty, validateEmail } from "@/utils/utils";
import { useRouter, useRoute } from "vue-router";
export default {
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const route = useRoute();
    // 主区域情报
    const contactInfo = ref({
      name: "",
      mail: "",
      content: "",
    });

    onMounted(() => {
      const from = localStorage.getItem("contactInfoFrom");
      if (from) {
        // 当页面加载时，检查 LocalStorage 是否有存储的值
        const savedData = localStorage.getItem("contactInfo");
        if (savedData) {
          contactInfo.value = JSON.parse(savedData);
        }
      } else {
        localStorage.removeItem("contactInfo");
        localStorage.removeItem("contactInfoFrom");
      }
    });

    const getErrorMessage = (message) => {
      ElMessage({
        message: message,
        type: "warning",
      });
    };

    const gotoReview = () => {
      if (isEmpty(contactInfo.value.name)) {
        getErrorMessage(t("contact-name") + t("error-required"));
        return;
      }
      if (isEmpty(contactInfo.value.mail)) {
        getErrorMessage(t("contact-email") + t("error-required"));
        return;
      }
      if (isEmpty(contactInfo.value.content)) {
        getErrorMessage(t("contact-content") + t("error-required"));
        return;
      }
      if (!validateEmail(contactInfo.value.mail)) {
        getErrorMessage(t("email-invalid"));
        return;
      }

      var path = "/reviewContactContent";
      var query = contactInfo.value;
      // 提交或页面跳转时保存到 LocalStorage
      localStorage.setItem("contactInfo", JSON.stringify(contactInfo.value));
      router.push({ path, query });
    };

    return {
      contactInfo,
      gotoReview,
    };
  },
};
</script>

<style scoped>
.contact {
  padding: 0 50px;
  background: white;
  height: 200%;
}
.contact-title {
  text-align: left;
  font-size: 50px;
  padding: 30px;
  padding-top: 60px;
}
.contact-title2 {
  text-align: left;
  padding: 30px;
}
.contact-content {
  padding: 0 200px;
  padding-bottom: 40px;
}
.contact-input {
  width: 340px;
}
.contact-field {
  font-weight: bold;
  line-height: 40px;
}
.contact-btn {
  height: 50px;
  width: 200px;
  background-color: #1a5276;
  color: white;
}

.contact-btn:hover {
  background-color: #56abe4;
  color: white;
}
@media (max-width: 768px) {
  .contact {
    padding: 20px 20px 0px 20px;
    background: white;
    height: 170%;
  }
  .contact-title {
    text-align: left;
    font-size: 30px;
    padding: 20px;
  }
  .contact-title {
    text-align: left;
    padding: 10px;
  }
  .contact-content {
    padding: 0 20px;
    padding-bottom: 20px;
  }
  .contact-input {
    width: 220px;
  }
}
</style>
